import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../Styles/Medyaf.css';

function PartnersLoop() {
  const { t, i18n } = useTranslation();
  const [isPaused, setIsPaused] = useState(false);

  const partnerImages = useMemo(() => {
    const fileNames = ['Rectangle.png'];

    for (let i = 1; i <= 21; i += 1) {
      fileNames.push(`Rectangle-${i}.png`);
    }

    return fileNames.map((name) => `/Medhyaf/${encodeURIComponent(name)}`);
  }, []);

  const loopCards = [...partnerImages, ...partnerImages, ...partnerImages];

  return (
    <div className="logoLoopSection">
      <h2
        className="logoLoopTitle"
        style={{ textAlign: i18n.language === 'ar' ? 'right' : 'left' }}
      >
        {t('mainMenu.romansiah_partners')}
      </h2>

      <div className="logoLoopViewport">
        <div
          className={`logoLoopTrack logoLoopTrackFromRight ${
            isPaused ? 'logoLoopTrackPaused' : ''
          }`}
        >
          {loopCards.map((imageSrc, index) => (
            <div
              key={`${imageSrc}-${index}`}
              className="logoLoopCard"
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
            >
              <img
                src={imageSrc}
                alt={`partner-${index + 1}`}
                loading="lazy"
                className="logoLoopImage1"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PartnersLoop;
